<template>
    <div class="create-third-form">
        <h2 class="mt-0 mr-4 flex-row mb-4">{{ settings.title }}</h2>

        <el-form
            :ref="popupStore"
            class="flex-column form-fields-company form-fields-shorten mb-0 flex-row jc-space"
            label-position="top"
            :model="model"
            :rules="createThirdRules"
            @submit.native.prevent="submitForm(popupStore)"
        >
            <!-- MAIN ${OPTIONS.TYPES.TYPE} FIELDS -->
            <component
                :is="`form-fields-${options.types.type}-shorten`"
                :data-bots-context="current"
                :current-store="popupStore"
                @change-type="changeType"
            ></component>

            <!-- CUSTOM FIELDS -->

            <form-fields-custom-fields
                :type-label="settings.label"
                :current-store="popupStore"
                :allow-add="false"
                :current-customfields="customfields"
            />

            <!-- POPUP NAV (save & cancel) -->
            <div class="pt-3 pl-5 flex-level flex-end span_12 zi-2">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    :data-bot="
                        getDatabot('btn-cancel', current, null, `${options.types.type}-popup`)
                    "
                    @click="$emit('close')"
                />
                <CompassButton
                    :label="$t.__('common.actions.save')"
                    type="primary"
                    class="ml-3"
                    submit
                    :data-bot="getDatabot('btn-save', current, null, `${options.types.type}-popup`)"
                />
            </div>
        </el-form>
    </div>
</template>

<script>
import FormFieldsCustomFields from 'vcomponents/thirds/thirdscomponents/FormFieldsCustomFields.vue';
import FormFieldsCompanyShorten from 'vcomponents/thirds/thirdscomponents/FormFieldsCompanyShorten.vue';
import FormFieldsContactShorten from 'vcomponents/thirds/thirdscomponents/FormFieldsContactShorten.vue';
import FormFieldsIndividualShorten from 'vcomponents/thirds/thirdscomponents/FormFieldsIndividualShorten.vue';
import FormMixins from 'mixins/FormMixins';
import DataBotsFormsMixins from 'mixins/DataBotsFormsMixins';

import createThirdModule from 'stores/forms/createThird';
import { checkNotBlank } from 'vcomponents/forms/rules/Rules';

export default {
    components: {
        FormFieldsCompanyShorten,
        FormFieldsContactShorten,
        FormFieldsIndividualShorten,
        FormFieldsCustomFields,
    },
    mixins: [FormMixins, DataBotsFormsMixins],
    props: {
        defaultValue: {
            default: '',
            require: false,
            type: Object,
        },
        options: {
            required: true,
            type: Object,
        },
        current: {
            require: true,
            type: String,
        },
    },
    data() {
        return {
            popupStore: 'createThirdPopup',
            store: createThirdModule,
            createTypeList: {
                company: {
                    label: window.i18n.__('Société'),
                    title: window.i18n.__('Ajouter une nouvelle société'),
                },
                individual: {
                    label: window.i18n.__('Particulier'),
                    title: window.i18n.__('Ajouter un nouveau particulier'),
                },
                contact: {
                    label: window.i18n.__('Contact'),
                    title: window.i18n.__('Créer un nouveau contact'),
                },
            },
            createThirdRules: {
                name: [
                    {
                        required: true,
                        message: window.i18n.__('Veuillez renseigner un nom'),
                        trigger: 'submit',
                    },
                    { validator: checkNotBlank, trigger: 'submit' },
                ],
            },
        };
    },
    computed: {
        settings() {
            return this.createTypeList[this.options.types.type];
        },
        model() {
            return this.$store.getters[`${this.popupStore}/getModel`];
        },
        state() {
            return this.$store.getters[`${this.popupStore}/getState`];
        },
        customfields() {
            return !_.isNil(this.defaultValue.customfields) ? this.defaultValue.customfields : null;
        },
    },
    created() {
        //Create the store for the create third popup
        if (this.$store.state.createThirdPopup) {
            this.$store.unregisterModule(this.popupStore);
        }
        this.$store.registerModule(this.popupStore, this.store);
        this.$store.dispatch(`${this.popupStore}/buildDefaultState`, {
            ...this.defaultValue,
            type: !_.isNil(this.options.types.subType)
                ? this.options.types.subType
                : this.options.types.type,
        });

        //unique rule for contact
        if (this.options.types.type === 'contact') {
            this.createThirdRules.email = [
                {
                    required: false,
                    type: 'email',
                    message: window.i18n.__('Veuillez renseigner une adresse email valide'),
                    trigger: 'blur',
                },
            ];
        }
    },
    beforeDestroy() {
        this.$store.unregisterModule(this.popupStore);
    },
    methods: {
        changeType(type) {
            this.$store.dispatch(`${this.popupStore}/fetchCustomFieldsByType`, type);
        },
        save() {
            let settings = {
                datas: this.state,
                type: this.options.types.type,
                index: this.options.index,
            };

            let call = 'add';
            //if contact and has a value at name, it's not a new third but an edit
            if (
                !this.options.imported &&
                !_.isNil(this.defaultValue?.name) &&
                this.defaultValue?.name !== '' &&
                this.options.types.type === 'contact'
            ) {
                call = 'edit';
            }

            if (this.options.imported) {
                settings.datas.imported = true;
            }
            this.$store.dispatch(`${this.current}/${call}Third`, settings).then(() => {
                this.$emit('next');
            });
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.create-third-form {
    .form-fields-shorten,
    .form-fields-shorten > section {
        overflow-x: hidden;
        .el-form-item > label {
            text-align: left !important;
            color: $gray-100;
            font-weight: 600;
            line-height: 20px;
        }
    }
}
</style>
